// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"2fa20a6a","513":"09664a4d","703":"54fb6c63","787":"0585193b"}[chunkId] + ".chunk.js";
};